import moment from 'moment'
export const getDateFormatter = (hasTime, date) => { // 默认返回yyyy-MM-dd HH-mm-ss
  let d
  if (!date) {
    d = new Date()
  } else {
    d = new Date(date)
  }
  if (!d.getFullYear) {
    console.warn('getDateFormatter时间参数格式错误，默认为当前时间')
    d = new Date()
  }
  var year = d.getFullYear()
  var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)
  var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
  var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
  var minute = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
  var second = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
  if (hasTime) { // 可传第二个参数false，返回yyyy-MM-dd
    return [year, month, day].join('-') + ' ' + [hour, minute, second].join(':')
  } else {
    return [year, month, day].join('-')
  }
}

export const getDateTimestampRange = () => {
  let sDate = new Date(new Date().setDate(1))
  return [new Date(getDateFormatter(false, sDate) + ' 00:00:00').getTime(), new Date(getDateFormatter(false) + ' 23:59:59').getTime()]
}

export const getDateRange = () => {
  let sDate = new Date(new Date().setDate(1))
  return [getDateFormatter(false, sDate), getDateFormatter(false)]
}

export const getDateObj = () => {
  let sDate = new Date(new Date().setDate(1))
  return [new Date(getDateFormatter(false, sDate) + ' 00:00:00'), new Date(getDateFormatter(false) + ' 00:00:00')]
}
// 获取过去30天-到今天的的时间区间
export const getLast30DaysRange = () => {
  return [moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
}



// WEBPACK FOOTER //
// ./src/utils/dateformatter.js